import React, { FC, ReactNode, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../redux/store.js";

export default function SavedQueriesTab({ children }: { children: ReactNode }) {
  const selectedFolder = useSelector(
    (state: RootState) => state.folder.selectedFolder,
  );
  return (
    <div className="right-panel">
      <div className="detail-page">
        <div className="header">{selectedFolder.name}</div>
        <div
          className="main-container fleet-detail-container"
          style={{ height: "100%", flex: 1 }}
        >
          <div className="dash-main-content">{children}</div>
        </div>
      </div>
    </div>
  );
}
